<template>
  <div>
    <div class="fboy">
      <div class="t-t">
        <div class="t-t-l">
          <span class="default-title">红人订单排行</span>
          <br/>
          (
          <div style="display: inline-block" v-if="searchCondition.time_type!=='all'">
            <span v-if="searchCondition.year">{{ searchCondition.year }}年</span>
            <span v-if="searchCondition.month">{{ searchCondition.month }}月</span>
            <el-tooltip class="item" effect="dark" content="以“下单时间”为维度" placement="top-start">
              <i class="el-icon-info" style="cursor: pointer;color: #8a8e99"/>
            </el-tooltip>
          </div>
          <div style="display: inline-block" v-else>
            全部
          </div>
          )
        </div>
        <div class="t-t-r r-col">
                    <span :class="activeTab=== 1 ?'t-t-r-i total-active':'t-t-r-i'"
                          @click="currentMonth">本月</span>
          <span :class="activeTab=== 2 ?'t-t-r-i total-active':'t-t-r-i'"
                @click="lastMonth">上月</span>
          <span :class="activeTab=== 3 ?'t-t-r-i total-active':'t-t-r-i'"
                @click="currentYear">本年</span>
          <span :class="activeTab === 4 ?'t-t-r-i total-active':'t-t-r-i'" @click="selectAll(4)">全部</span>
          <br/>
          <div class="date-col">
            <MonthSelectGroup @selected="selectedMonth"/>
          </div>
          <div class="date-col">
            <YearSelectGroup @selected="selectedYear"/>
          </div>
        </div>
      </div>
      <div class="grid-2-1" style="margin-top:30px">
        <div class="line-r">
          <el-form :model="searchCondition" label-width="70px" class="forms" inline size="mini">
            <el-form-item label="红人名称">
              <el-input class="el-input-m" v-model="searchCondition.name"
                        placeholder="请输入红人名称（支持模糊匹配）"
                        @change="search" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                  type="primary"
                  @click="search"
                  icon="el-icon-search"
              >查询
              </el-button>
              <el-button type="text" @click="reset" style="margin-left:30px;">重置
              </el-button>
            </el-form-item>
          </el-form>
          <div class="default-table">
            <ape-table
                ref="refKolSummaryTable"
                :data="dataList"
                :paging-data="pagingData"
                :columns="[]"
                :loading="loadingStatus"
                :pagingData="pagingData"
                @switchPaging="switchPaging"
                @changeTableSort="changeTableSort"
                :summary-method="getSummaries"
                show-summary
                highlight-current-row
                max-height="600px"
            >
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="红人（KOL）名称" prop="name" min-width="200">
                <template slot-scope="scope">
                  <el-link type="primary" :title="scope.row.id"
                           @click="showDetailPage(scope.row.id)">{{
                      scope.row.nickname
                    }}
                  </el-link>
                </template>
              </el-table-column>
              <el-table-column label="订单数" prop="order_count" sortable="custom" min-width="100">
                <template slot-scope="scope">
                  <span>{{ gFunc.numberFormat(scope.row.order_count) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="订单总金额" prop="sum_money" sortable="custom" min-width="100">
                <template slot-scope="scope">
                  <span>{{ gFunc.numberFormat(scope.row.sum_money) }}</span>
                </template>
              </el-table-column>
            </ape-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApeTable from "@/components/ApeTable";
import {getFboyData} from "@/api/home";

export default {
  name: "KOLAdOrderRank",
  components: {ApeTable},
  props: {
    year: [Number, String],
    month: [Number, String],
  },
  data() {
    return {
      activeTab: 1,
      searchCondition: {
        year: null,
        month: null,
        name: null,
        time_type: 'not_all',
        start_time: 0,
        end_time: 0,
        bool_exec: 2
      },
      loadingStatus: false,
      dataList: [],
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 100
      },
      cusSort: {
        order: '',
        prop: ''
      },
      orderSort: {order_count: 'descending'},//默认排序规则
      orderSortObj: {order_count: 'descending'},//默认排序规则
      totalPaymentData: {} // 回款统计
    }
  },
  watch: {
    "searchCondition.year"() {
      this.searchCondition.time_type = 'not_all'
    },
    "searchCondition.month"() {
      this.searchCondition.time_type = 'not_all'
    },
  },
  created() {
    this.searchCondition.year = this.year
    this.searchCondition.month = this.month
  },
  mounted() {
    this.initList()
  },
  methods: {
    showDetailPage() {
      this.$notify.warning('开发中..')

    },
    changeTableSort({prop, order}) {
      this.orderSortObj = {order: order, prop: prop}
      // let orderSort = {}
      // if (order) {
      //   orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      // }
      //
      // this.orderSort = orderSort
      this.initList()
    },
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index < 1) {
          return
        }
        if (index === 1) {
          sums[index] = '合计:'
          return
        }
        if (['order_count', 'sum_money'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          // 格式化数据
          switch (column.property) {
            case 'order_count':
              sums[index] = this.gFunc.numberFormat(sums[index])
              break;
            case 'sum_money':
              sums[index] = this.gFunc.numberFormat(sums[index])
              break;
            default:
              break
          }
        }
      })

      return sums
    },
    selectAll(activeTab) {
      this.activeTab = activeTab
      this.searchCondition.time_type = "all";
      // this.searchCondition.year = null;
      // this.searchCondition.month = null;
      this.search()
    },
    selectedYear(val) {
      this.activeTab = null
      this.searchCondition.year = val.year + ''
      this.searchCondition.month = null
      this.search()
    },
    selectedMonth(val) {
      this.activeTab = null
      this.searchCondition.year = val.year + ''
      this.searchCondition.month = val.month
      this.search()
    },
    currentYear() {
      this.activeTab = 3
      let date = new Date()
      this.searchCondition.year = date.getFullYear()
      this.searchCondition.month = null
      this.search()
    },
    lastMonth() {
      this.activeTab = 2
      let date = new Date()
      //分页页面-默认上月
      date.setMonth(date.getMonth() - 1)
      let year = date.getFullYear() + ''
      let month = date.getMonth() + 1;
      this.searchCondition.year = year
      this.searchCondition.month = month
      this.search()
    },
    currentMonth() {
      this.activeTab = 1
      let date = new Date()
      //分页页面-默认上月
      // date.setMonth(date.getMonth() - 1)
      let year = date.getFullYear() + ''
      let month = date.getMonth() + 1;
      this.searchCondition.year = year
      this.searchCondition.month = month

      this.search()
    },
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name
      }
      if (this.searchCondition.time_type) {
        condition.time_type = this.searchCondition.time_type
      }

      if (this.searchCondition.bool_exec) {
        condition.bool_exec = this.searchCondition.bool_exec
      }

      if (this.searchCondition.year) {
        let year = this.searchCondition.year
        let month = this.searchCondition.month
        if (month) {
          month = parseInt(month)
          let day = new Date(parseInt(year), month, 0);
          let daycount = day.getDate();//最后一天
          condition.start_time = year + '-' + (month > 9 ? month : '0' + month) + '-01'
          condition.end_time = year + '-' + (month > 9 ? month : '0' + month) + '-' + daycount
        } else {
          condition.start_time = year + '-01-01'
          condition.end_time = year + '-12-31'
        }

        //时间转成时间戳
        condition.start_time = (new Date(condition.start_time).getTime()) / 1000
        condition.end_time = (new Date(condition.end_time).getTime()) / 1000
      }

      return condition
    },
    // 切换页码操作
    async switchPaging() {
      await this.initList()
    },
    formatNumber(val) {//格式化数据
      let newNum = ''
      if (!(val) || val === 0 && val === '0.00' && isNaN(val)) {
        newNum = '0'
        return newNum;
      } else {
        newNum = parseInt(Number(val).toFixed(0))
        return newNum.toLocaleString();
      }
    },
    //客户消费详情
    initList(type) {
      let searchCondition = this.handleSearchCondition()
      let pagingInfo = this.$refs['refKolSummaryTable'].getPagingInfo(type)

      Object.assign(searchCondition, {
        page: pagingInfo.current_page,
        per_page: pagingInfo.page_size
      }, this.orderSortObj)

      this.loadingStatus = true
      getFboyData(searchCondition).then(res => {
        this.loadingStatus = false
        this.dataList = res.model.data || [];
        this.pagingData.total = res.model.total || 0
      })
    },
    search() {
      if (this.$refs['refKolSummaryTable'])
        this.$refs['refKolSummaryTable'].handleCurrentChange(1)
    },
    reset() {
      this.searchCondition.name = "";
      this.initList()
    },
  }
}
</script>

<style scoped>
.default-title {
  font-weight: bold;
  font-size: 18px;
}

.fboy {
  height: 380px;
  background: #fff;
  padding: 24px;
  box-sizing: border-box;
}

.fboy {
  height: 860px;
  margin: 5px 0;
}

.t-t, .t-b {
  display: grid;
  grid-template-columns: 15% 85%;
  justify-items: left;
}

.t-t {
  grid-template-rows: 50px;
  align-items: center;
}

.t-b {
  grid-template-rows: 280px;
}

.t-t-r-i {
  margin: 0 10px;
  height: 40px;
  display: inline-block;
  line-height: 40px;
  cursor: pointer;
}

.total-active {
  color: #3296FF;
  border-bottom: 2px solid #3296FF;
}

.amount {
  font-size: 20px;
  font-weight: 400;
  color: rgba(50, 150, 255, 1);
  padding-top: 10px;
}

.t-b-l {
  display: grid;
  align-content: space-evenly;
  justify-content: left;
  padding-left: 20px;
}

.t-b-l > div {
  text-align: left;
}

#totalPaymentChart {
  width: calc((100vw - 0px - 48px) * 0.85);
  height: calc(380px - 48px - 50px);
}

.line-rr > .t-t-r {
  text-align: left;
}

.r-col {
  text-align: left;
}

.date-col {
  display: inline-block;
  margin-left: 10px;
  margin-right: 10px;
}
</style>
